<template>
  <kst-page-new
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details
      :userData="userData" 
      :categoryOptions="categoryOptions"
      :paymentOptions="paymentOptions"
      :warehouseOptions="warehouseOptions"
    />
  </kst-page-new>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../ExpModel.js";
import Services from "../../../services/Api/ExpenseServices.js";

import Details from "./ExpN_Details.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    Details
  },
  data: () => ({
    userData: {},
    categoryOptions: {},
    paymentOptions: {},
    warehouseOptions: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(loadNew) {
      this.resetData();

      const config = Services.getNewData();
      loadNew(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.categoryOptions = Model.getExpenseCategoryOptions(
        data.ExpenseSubCatList
      );
      this.paymentOptions = Model.getPaymentOptions(data.PaymentTypeList);
      this.warehouseOptions = Model.getWarehouseOptions(data.WarehouseList);

      Model.New.setDetailsByExpenseCategoryOptions(
        this.userData, this.categoryOptions
      );
      Model.New.setDetailsByPaymentList(this.userData, data.PaymentTypeList);
      Model.New.setDetailsByWarehouseList(this.userData, data.WarehouseList);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData);
      const config = Services.postData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
    }
  }
}
</script>